import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Scale, X, ArrowRight } from 'lucide-react';
import { useFavorites } from '../context/FavoritesContext';

/**
 * Fixed bottom-bar that appears when 2-3 products are flagged for comparison.
 * Click „Vergleichen" → navigate to /vergleich (CompareProducts page).
 */
const CompareBar = () => {
  const { compareIds, toggleCompare, clearCompare, MAX_COMPARE } = useFavorites();
  const navigate = useNavigate();
  if (compareIds.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-white shadow-2xl rounded-full border-2 border-sky-500 px-4 py-2 flex items-center gap-2 md:gap-3"
      data-testid="compare-bar"
    >
      <Scale className="h-5 w-5 text-sky-600" />
      <span className="text-sm font-bold text-neutral-900 tabular-nums">
        {compareIds.length}/{MAX_COMPARE}
      </span>
      <span className="hidden sm:inline text-xs text-neutral-500">zum Vergleich</span>
      <div className="flex items-center gap-1">
        {compareIds.map((pid, i) => (
          <button
            key={pid}
            type="button"
            onClick={() => toggleCompare(pid)}
            className="w-5 h-5 rounded-full bg-sky-100 text-sky-700 hover:bg-rose-100 hover:text-rose-600 inline-flex items-center justify-center"
            aria-label="Aus Vergleich entfernen"
            data-testid={`compare-bar-remove-${i}`}
          >
            <X className="h-3 w-3" />
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={clearCompare}
        className="text-xs text-neutral-500 hover:text-neutral-700 hidden sm:inline"
        data-testid="compare-bar-clear"
      >
        Alle löschen
      </button>
      <button
        type="button"
        onClick={() => navigate('/vergleich')}
        disabled={compareIds.length < 2}
        className="ml-2 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-sky-700 hover:bg-sky-800 disabled:bg-neutral-300 text-white font-bold text-sm transition-colors"
        data-testid="compare-bar-go"
      >
        Vergleichen
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default CompareBar;
